/* eslint-disable max-len */
/* eslint-disable no-param-reassign */
import { useCallback, useEffect } from 'react';
import _, { isEmpty } from 'lodash';
import PropTypes from 'prop-types';
import { useDataRefresh } from '@xengage/gw-portals-viewmodel-react';
// eslint-disable-next-line import/no-extraneous-dependencies
import { appendMetadataWithIndex } from 'ml-portals-util-react';
import { MetadataContent } from '@jutro/legacy/uiconfig';
import '@xengage/gw-platform-translations';
import {v1 as uuid} from 'uuid';
import metadata from './MLPAAgentTermMultipleOptComponent.metadata.json5';

import React from 'react';

const COVERAGE_IS_TERM_AVAILABLITY = [
"PACollisionCovIs_Ext",
"PACompCovIs_Ext",
"PAAgreedValueCovIs_Ext",
"PADiminishDedCovIs_Ext",
"PACustomEquipCovIs_Ext",
"PARoadAssistCovIs_Ext",
"PARentalCovIs_Ext",
"PANewVehReplaceCovIs_Ext",
"PALeaseorLoanGapCovIs_Ext",
"PAAutoExtraCovIs_Ext",
"PATravelCovIs_Ext",
"PARideshareCovIs_Ext",
"PALocalDeliveryCovIs_Ext",
"PAWorldwideLiabCovIs_Ext",
"PAOEMCovIs_Ext",
"PANonOwnedCovIs_Ext",
"PASafetyGlassDedWaiverCovIs_Ext",
"PAAgreedValueCollectibleCovIs_Ext"]


function MLPAAgentTermMultipleOptComponent(props) {
    const {
        coverage,
        getSingleOption,
        term,
        covIndex,
        termIndex,
        hideMexicoDecliningAmount 
    } = props;
    const { refreshData } = useDataRefresh();

    useEffect(() => {
        if (coverage.name === 'First Party Benefits') {
            const combinationPackageValue = coverage.terms.filter((cov) => cov.name === 'Combination Package' && cov.value === undefined);
            if (_.isEmpty(combinationPackageValue) && coverage.terms.length === 9) {
                coverage.terms.splice(1, 4);
            } else if (!_.isEmpty(combinationPackageValue) && coverage.terms.length === 9) {
                coverage.terms.splice(5, 4);
            }
        }
    }, [coverage.terms, coverage.name]);

    // const showHideOptions
    const formatOptionAvailableVals = (options) => {
        if (!options) return [];
        return options.map((opt) => ({
            code: opt.code !== undefined ? opt.code : uuid(),
            name: {
                id: opt.code !== undefined ? opt.code : uuid(),
                defaultMessage: opt.name
            }
        }));
    };

    const formatOptionAvailableValsForRadio = (options) => {
        const availableValues = formatOptionAvailableVals(options);

        const isCoverageTerm = COVERAGE_IS_TERM_AVAILABLITY.includes(term.codeIdentifier_ML);

        if (isCoverageTerm) {
            return availableValues.map((item) => ({
                code: item.code,
                name: {
                    id: item.code !== undefined ? item.code : uuid(),
                    defaultMessage: item.code === "true" ? "Insured Requested" : "Offered and Consented"
                }
            }))
        }

        return availableValues

    }

    const multipleOptionTermChanged =(selectedOption, termParam) => {
        termParam.value = selectedOption;
    };

    const updateTermInput = () => {
        term.applyNewValue();
    };

    const setInputTermVal = (value) => {
        term.newValue = value;
        refreshData();
    }

    const hasMultipleOptions = () => {
        return !!term.hasOptions && term.options.length > 1;
    };

    const hasNoOptions = () => {
        return (!term.hasOptions || term.options.length === 0) && !term.readOnly && term.isEditable_ML;
    };  

    const resolvers = {};

    const isRadioButtonAvailable = useCallback(()=>{
        // Can be Convert it to Generic if requirements ask for a Radio Button , 
        // For now Coverage Is is only term that is requested to have radio button
        const isAvailable = COVERAGE_IS_TERM_AVAILABLITY.includes(term.codeIdentifier_ML);
        const isOptCoverage = coverage.coverageCategoryCode === "PAOptCovGrp_ML"
        
        return isAvailable && !isEmpty(term.options) && !isOptCoverage
    },[coverage, term])

    const isMexicoOrDecliningCoverage =
    coverage.name === 'Limited Mexico Coverage' ||
    coverage.name === 'Declining Deductible';
 
    const shouldHideSingleOptionAmount =hideMexicoDecliningAmount && isMexicoOrDecliningCoverage;
    const overrides = {
        [`selectContainer${covIndex}${termIndex}`]: {
            visible: hasMultipleOptions() && !term.readOnly,
        },
        [`termSelect${covIndex}${termIndex}`]: {
            label: coverage.name,
            hideLabel: true,
            value: term.value,
            availableValues: formatOptionAvailableVals(term.options),
            onValueChange: multipleOptionTermChanged,
            path: term,
            disabled: !coverage.selected || !term.isEditable_ML,
            visible : !isRadioButtonAvailable()
        },
        [`termRadioSelect${covIndex}${termIndex}`]: {
            label: coverage.name,
            hideLabel: true,
            value: term.value,
            availableValues: formatOptionAvailableValsForRadio(term.options),
            onValueChange: multipleOptionTermChanged,
            path: term,
            disabled: !coverage.selected || !term.isEditable_ML,
            visible: isRadioButtonAvailable()
        },
        [`singleOptionSpan${covIndex}${termIndex}`]: {
            visible:!shouldHideSingleOptionAmount && !!term.hasOptions &&(term.options.length === 1 || term.readOnly),
            content: getSingleOption(term)
        },
        [`termInput${covIndex}${termIndex}`]: {
            visible: hasNoOptions() || (term?.isEditable_ML && term?.name ==="Diminishing Deductible Effective Date"),
            value: term.newValue,
            onValueChange: setInputTermVal,
            onBlur: updateTermInput,
            path: term,
            disabled: !coverage.selected || !term.isEditable_ML,
            readOnly: term.readOnly
        }
    };

    const updatedMetadata = appendMetadataWithIndex(metadata.componentContent, `${covIndex}${termIndex}`);

    return <MetadataContent uiProps={updatedMetadata} overrideProps={overrides} {...resolvers} />;
}

MLPAAgentTermMultipleOptComponent.propTypes = {
    coverage: PropTypes.shape({}),
    editMode: PropTypes.bool,
    getChosenTermValue: PropTypes.func,
    hasSingleOption: PropTypes.func,
    getSingleOption: PropTypes.func,
    isYesNoOption: PropTypes.func,
    hasMultipleOptions: PropTypes.func,
    getOptionName: PropTypes.func,
    hasNoOptions: PropTypes.func,
    term: PropTypes.shape({}),
    covIndex: PropTypes.number,
    termIndex: PropTypes.number
};

export default MLPAAgentTermMultipleOptComponent;
